export const getIconByFormula = (
  formulaVersion,
  black = false,
  blue = false
) => {
  let icon = null
  switch (formulaVersion) {
    case 'AKERN 2023':
      icon = 'weight_control'
      break
    case 'sport':
      icon = 'sport_and_activity'
      break
    case 'hbo2025':
      icon = 'bodygram_advanced'
      break
    case 'comparison':
      icon = 'info'
      break
    case 'pediatric':
      icon = 'info'
      break
    default:
      icon = 'bodygram_standard'
      break
  }
  if (icon) {
    icon = 'fapps/' + icon
  }
  if (icon && black) {
    icon = icon + '_black'
  }
  if (icon && blue) {
    icon = icon + '_blue'
  }
  return icon
}
